export const COUNTS_SEARCH_REQUEST = "search/library/counts/request";
export const COUNTS_SEARCH_SUCCESS = "search/library/counts/success";

export const SEARCH_BOOK_CONTENT_REQUEST = "search/book/content/request";
export const SEARCH_BOOK_CONTENT_SUCCESS = "search/book/content/success";
export const SEARCH_BOOK_CONTENT_FAILURE = "search/book/content/failure";

export const SEARCH_BOOK_METADATA_REQUEST = "search/book/metadata/request";
export const SEARCH_BOOK_METADATA_SUCCESS = "search/book/metadata/success";
export const SEARCH_BOOK_METADATA_COMPLETE = "search/book/metadata/complete";
export const SEARCH_BOOK_METADATA_FAILURE = "search/book/metadata/failure";

export const LICENSE_SOURCE = "license";
export const BRIDGE_SOURCE = "bridge";
